import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FooterContentComponent } from './footer-content/footer-content.component';
import { RouterModule } from '@angular/router';
import { PrivateContestComponent } from './private-contest/private-contest.component';
import { ViewSelectionPopupComponent } from './view-selection-popup/view-selection-popup.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AgeVerificationModalComponent } from './age-verification-modal/age-verification-modal.component';
import { Under18ModalComponent } from './under-18-modal/under-18-modal.component';
import { ProUpsellModalComponent } from './pro-upsell-modal/pro-upsell-modal.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    NgbTooltipModule
  ],
  declarations: [
    FooterContentComponent,
    PrivateContestComponent,
    ViewSelectionPopupComponent,
    AgeVerificationModalComponent,
    Under18ModalComponent,
    ProUpsellModalComponent
  ],
  entryComponents: [
    PrivateContestComponent, 
    ViewSelectionPopupComponent,
    AgeVerificationModalComponent,
    Under18ModalComponent,
    ProUpsellModalComponent
  ],

  exports: [
    FooterContentComponent, 
    PrivateContestComponent,
    AgeVerificationModalComponent,
    Under18ModalComponent,
    ProUpsellModalComponent
  ]
})
export class SharedModule { }



